module.exports = __webpack_public_path__ + "static/media/BalsamiqSans-Regular.d0e0c9d1.ttf";